import { getDetailEventSummaryAttribute as getDetailEventSummaryAttributeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type EventAttributeProps = {
    attribute?: string;
}

export const getDetailEventSummaryAttribute = (): EventAttributeProps => getDetailEventSummaryAttributeDiagram();
